import { StepsContext } from '../contexts/Steps'
import React from 'react'

export default function Errors () {
  const { errors } = React.useContext(StepsContext)

  if (errors === null || errors.length < 1) {
    return null
  }

  return (
    <ul className={'error-box'}>
      {errors.map((e, i) => <li key={i} className={'error'}>{e}</li>)}
    </ul>
  )
}